module.exports = __webpack_public_path__ + "static/media/turnaround_overnight_image.95434f77.png";